export const isIEorEdge =
  !!navigator.userAgent.match(/Trident/g) ||
  !!navigator.userAgent.match(/MSIE/g) ||
  !!navigator.userAgent.match(/Edge/);

export const base64ToBlob = (data, type) => {
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type });
};



// WEBPACK FOOTER //
// ./src/common/IEHelper.js